//import React from 'react'
import { connect } from 'react-redux';
import * as rootObject from '../reducers';
import  Vehicles  from '../components/Vehicles';
import { newVehicle } from '../actions';

const DEFAULT_VALUES = {
    label: "",
    make: "",
    model: "",
    year: new Date().getFullYear(),
    color: "",
    starting_odometer: 0,
    trim: "",
    VIN: "",
    plate: ""
}

const mapStateToProps = (state, ownProps) => { //console.log('own props', ownProps.match.params.car,rootObject.getCarDetails(state,ownProps.match.params.car))
	
    

    return {
		...ownProps,
		initial_state:Object.assign(DEFAULT_VALUES,rootObject.getCarDetails(state,ownProps.match.params.car))
	}
}

const VehicleContainer = connect(
  mapStateToProps,
  {onChange:newVehicle}
)(Vehicles)

export default VehicleContainer


// WEBPACK FOOTER //
// ./src/containers/VehicleContainer.js